import React, { useEffect, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import { Scrollbars } from "react-custom-scrollbars";
// import { LogoImg, LogoSmallImg } from "../_components/imagepath";
import Loading from "../pages/Reusecomponent/Loading";

const Sidebar = (props) => {
  const [isSideMenu, setSideMenu] = useState("");
  const [isSideMenuLevel, setSideMenuLevel] = useState("");
  const [isSideMenuLevel2, setSideMenuLevel2] = useState("");
  const [loginUserRole, setloginUserRole] = useState("");
  const [loading, setLoading] = useState(false);

  const simulateAsyncOperation = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 200);
  };

  useEffect(() => {
    simulateAsyncOperation();
  }, []);
  
  const toggleSidebar = (value) => {
    console.log(value);
    setSideMenu(value);
  };
  const toggleSidebar1 = (value) => {
    console.log(value);
    setSideMenuLevel(value);
  };
  const toggleSidebar2 = (value) => {
    console.log(value);
    setSideMenuLevel2(value);
  };


  useEffect(() => {
    const storedRole = sessionStorage.getItem('userRole') || localStorage.getItem('userRole');
    if (storedRole) {
      setloginUserRole(storedRole);
      console.log("role is found-->", loginUserRole);
    } else {
      console.log("role is not found-->");
    }
    function handleMouseOver(e) {
      e.stopPropagation();
      if (
        document.body.classList.contains("mini-sidebar") &&
        document.querySelector("#toggle_btn").offsetParent !== null
      ) {
        var targ = e.target.closest(".sidebar");
        if (targ) {
          document.body.classList.add("expand-menu");
          document
            .querySelectorAll(".subdrop + ul")
            .forEach((ul) => (ul.style.display = "block"));
        } else {
          document.body.classList.remove("expand-menu");
          document
            .querySelectorAll(".subdrop + ul")
            .forEach((ul) => (ul.style.display = "none"));
        }
        return false;
      }
    }

    document.addEventListener("mouseover", handleMouseOver);

    return () => {
      document.removeEventListener("mouseover", handleMouseOver);
    };
  }, []);

  useEffect(() => {
    $(document).on("change", ".sidebar-type-four input", function () {
      if ($(this).is(":checked")) {
        $(".sidebar").addClass("sidebar-eight");
        $(".sidebar-menu").addClass("sidebar-menu-eight");
        $(".menu-title").addClass("menu-title-eight");
        $(".header").addClass("header-eight");
        $(".header-left-two").addClass("header-left-eight");
        $(".user-menu").addClass("user-menu-eight");
        $(".dropdown-toggle").addClass("dropdown-toggle-eight");
        $(".white-logo").addClass("show-logo");
        $(
          ".header-one .header-left-one .logo:not(.logo-small), .header-five .header-left-five .logo:not(.logo-small)"
        ).addClass("hide-logo");
        $(".header-two .header-left-two .logo:not(.logo-small)").removeClass(
          "hide-logo"
        );
        $(".header-two .header-left-two .dark-logo").removeClass("show-logo");
      } else {
        $(".sidebar").removeClass("sidebar-eight");
        $(".sidebar-menu").removeClass("sidebar-menu-eight");
        $(".menu-title").removeClass("menu-title-eight");
        $(".header").removeClass("header-eight");
        $(".header-left-two").removeClass("header-left-eight");
        $(".user-menu").removeClass("user-menu-eight");
        $(".dropdown-toggle").removeClass("dropdown-toggle-eight");
        $(".white-logo").removeClass("show-logo");
        $(
          ".header-one .header-left-one .logo:not(.logo-small), .header-five .header-left-five .logo:not(.logo-small)"
        ).removeClass("hide-logo");
      }
    });
  }, []);

  const hasAccess = (allowedRoles) => allowedRoles.includes(loginUserRole);

  let pathName = props.location.pathname;

  return (
    <>
    {loading && <Loading />}
      <div className="sidebar" id="sidebar">
        <Scrollbars
          autoHide
          autoHideTimeout={1000}
          autoHideDuration={200}
          autoHeight={true}
          autoHeightMin={0}
          autoHeightMax="95vh"
          thumbSize={300}
          universal={false}
          hideTracksWhenNotNeeded={true}
        >
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              {/* Main Menu */}
              <ul>
                {!hasAccess(["super-admin"]) && (
                  <li className={`${["/dashboard", "/admindashboard", "/teamdashboard"].includes(pathName) ? "active" : ""}`}>
                    <Link to={loginUserRole === "admin" ? "/admindashboard" : loginUserRole === "application-assistant" ? "/teamdashboard" : "/dashboard"}>
                      <i className="fas fa-tachometer-alt"></i>{" "}
                      <span> Dashboard </span>
                    </Link>
                  </li>
                )}
                {hasAccess(["super-admin"]) && (
                  <>
                    <li className="menu-title">
                      <span>SUPER ADMIN MANAGEMENT</span>
                    </li>
                    <li className={`${pathName === "/superadmin" && !location.search ? "active" : ""}`}>
                      <Link to="/superadmin">
                        <i className="fas fa-chart-pie text-primary"></i>{" "}
                        <span> Overview </span>
                      </Link>
                    </li>
                    <li className={`${location.search.includes("tab=admin") ? "active" : ""}`}>
                      <Link to="/superadmin?tab=admin">
                        <i className="fas fa-user-tie text-primary"></i>{" "}
                        <span> Admins </span>
                      </Link>
                    </li>
                    <li className={`${location.search.includes("tab=user") ? "active" : ""}`}>
                      <Link to="/superadmin?tab=user">
                        <i className="fas fa-user-graduate text-success"></i>{" "}
                        <span> Students </span>
                      </Link>
                    </li>
                    <li className={`${location.search.includes("tab=application-assistant") ? "active" : ""}`}>
                      <Link to="/superadmin?tab=application-assistant">
                        <i className="fas fa-headset text-info"></i>{" "}
                        <span> Application Assistants </span>
                      </Link>
                    </li>
                    <li className={`${location.search.includes("tab=counsellor") ? "active" : ""}`}>
                      <Link to="/superadmin?tab=counsellor">
                        <i className="fas fa-chalkboard-teacher text-warning"></i>{" "}
                        <span> Counsellors </span>
                      </Link>
                    </li>
                    <li className={`${location.search.includes("tab=loan-officer") ? "active" : ""}`}>
                      <Link to="/superadmin?tab=loan-officer">
                        <i className="fas fa-hand-holding-usd text-secondary"></i>{" "}
                        <span> Loan Officers </span>
                      </Link>
                    </li>
                    <li className={`${location.search.includes("tab=importData") ? "active" : ""}`}>
                      <Link to="/superadmin?tab=importData">
                        <i className="fas fa-file-excel text-success"></i>{" "}
                        <span> Master Data Import </span>
                      </Link>
                    </li>
                    <li className={`${location.search.includes("tab=helpDesk") ? "active" : ""}`}>
                      <Link to="/superadmin?tab=helpDesk">
                        <i className="fas fa-headset text-danger"></i>{" "}
                        <span> Help Desk </span>
                      </Link>
                    </li>
                  </>
                )}
                {hasAccess(["user"]) && (
                  <li className={`${"/profile" === pathName ? "active" : ""}`}>
                    <Link to="/profile">
                      <i className="fas fa-user-circle"></i> {" "}
                      <span> Profile </span>
                    </Link>
                  </li>
                )}
                <li
                  className={`${"/normalsearch" === pathName ? "active" : ""}`}
                >
                  <Link to="/normalsearch"> 
                    <i className="fas fa-search"></i> {" "}
                    <span> Search Program </span>
                  </Link>
                </li>
                {hasAccess(["user"]) && (
                  <li
                    className={`${"/myApplications" === pathName ? "active" : ""
                      }`}
                  >
                    <Link to="/myApplications">
                      <i className="fas fa-file-alt"></i>{" "}
                      <span> My Applications  </span>
                    </Link>
                  </li>
                )}
                {hasAccess(["user"]) && (
                  <li
                    className={`${"/wishList" === pathName ? "active" : ""
                      }`}
                  >
                    <Link to="/wishList">
                      <i className="fas fa-heart text-danger"></i>{" "}
                      <span>Wishlist </span>
                    </Link>
                  </li>
                )}

                {hasAccess(["admin", "application-assistant"]) && (
                  <li
                    className={`${"/adminstudentview" === pathName ? "active" : ""
                      }`}
                  >
                    <Link to="/adminstudentview">
                      <i className="fas fa-clipboard-list"></i>{" "}
                      <span>All Applications  </span>
                    </Link>
                  </li>
                )}
                {hasAccess(["admin"]) && (
                  <li
                    className={`${"/allstudents" === pathName ? "active" : ""
                      }`}
                  >
                    <Link to="/allstudents">
                      <i className="fas fa-users"></i>{" "}
                      <span>All Students  </span>
                    </Link>
                  </li>
                )}
                 {hasAccess(["admin"]) && (
                  <li
                    className={`${"/profileShortlisting" === pathName ? "active" : ""
                      }`}
                  >
                    <Link to="/profileShortlisting">
                      <i className="fas fa-list-ul"></i>{" "}
                      <span>Profile Shortlisting  </span>
                    </Link>
                  </li>
                )}
                {hasAccess(["admin"]) && (
                  <li
                    className={`${"/issues" === pathName ? "active" : ""
                      }`}
                  >
                    <Link to="/issues">
                      <i className="fas fa-bug"></i>{" "}
                      <span>Issues</span>
                    </Link>
                  </li>
                )}
                {hasAccess(["admin"]) && (
                  <li
                    className={`${"/admindeals" === pathName ? "active" : ""
                      }`}
                  >
                    <Link to="/admindeals">
                      <i className="fas fa-handshake"></i>
                      <span>Deals</span>
                    </Link>
                  </li>
                )}
                {hasAccess(["admin"]) && (
                  <li
                    className={`${"/leadsData" === pathName ? "active" : ""
                      }`}
                  >
                    <Link to="/leadsData">
                      <i className="fas fa-chart-line"></i>
                      <span>Leads Data</span>
                    </Link>
                  </li>
                )}
                {hasAccess(["admin"]) && (
                  <li
                    className={`${"/loanapplications" === pathName ? "active" : ""
                      }`}
                  >
                    <Link to="/loanapplications">
                      <i className="fas fa-hand-holding-usd"></i>
                      <span>Loan Applications</span>
                    </Link>
                  </li>
                )}
                {hasAccess(["user"]) && (
                  <li
                    className={`${"/applyloan" === pathName ? "active" : ""}`}
                  >
                    <Link to="/applyloan">
                      <i className="fas fa-money-check-alt"></i>
                      <span> Apply for Loan </span>
                    </Link>
                  </li>
                )}
                {hasAccess(["user"]) && (
                  <li
                    className={`${"/buildsop" === pathName ? "active" : ""}`}
                  >
                    <Link to="/buildsop">
                      <i className="fas fa-file-signature"></i>
                      <span>  Build my SOP</span>
                    </Link>
                  </li>
                )}

                <li
                  className={`${"/writetous" === pathName ? "active submenu" : "submenu"
                    }`}
                >
                  <Link
                    to="#"
                    className={isSideMenu == "HelpDesk" ? "subdrop" : ""}
                    onClick={() =>
                      toggleSidebar(isSideMenu == "HelpDesk" ? "" : "HelpDesk")
                    }
                  >
                    <i className="fas fa-headset"></i>
                    <span> Help Desk</span> <span className="menu-arrow" />
                  </Link>
                  {isSideMenu == "HelpDesk" ? (
                    <ul
                      style={{
                        display: isSideMenu == "HelpDesk" ? "block" : "none",
                      }}
                    >
                      <li>
                        <Link
                          to="/writetous"
                          className={`${"/writetous" === pathName ? "active" : ""
                            }`}
                        >
                          Write To us
                        </Link>
                      </li>
                    </ul>
                  ) : (
                    ""
                  )}
                </li>




              </ul>
              {/* /Main Menu*/}
              {/* Management */}
              <ul>

                {hasAccess(["user"]) && (
                  <li
                    className={`${"/referaFriend" === pathName ? "active submenu" : "submenu"
                      }`}
                  >
                    <Link
                      to="#"
                      className={isSideMenu == "MyNetwork" ? "subdrop" : ""}
                      onClick={() =>
                        toggleSidebar(
                          isSideMenu == "MyNetwork" ? "" : "MyNetwork"
                        )
                      }
                    >
                      <i className="fas fa-network-wired"></i>
                      <span> My Network</span> <span className="menu-arrow" />
                    </Link>
                    {isSideMenu == "MyNetwork" ? (
                      <ul
                        style={{
                          display: isSideMenu == "MyNetwork" ? "block" : "none",
                        }}
                      >
                        <li>
                          <Link
                            to="/referaFriend"
                            className={`${"/referaFriend" === pathName ? "active" : ""
                              }`}
                          >
                            Refer A friend
                          </Link>
                        </li>
                      </ul>
                    ) : (
                      ""
                    )}
                  </li>
                )}
                <li className={`${"/" === pathName ? "active" : ""}`}>
                  <Link to="/">
                    <i className="fas fa-sign-out-alt"></i>
                    <span>Sign Out</span>
                  </Link>
                </li>
              </ul>
              {/* /UI Interface */}
            </div>
          </div>
        </Scrollbars>
      </div>
    </>
  );
};

export default withRouter(Sidebar);
